import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullSize = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23 23",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_2317",
		"data-name": "Group 2317",
		transform: "translate(-1604.806 -566)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_2311",
			"data-name": "Group 2311",
			transform: "translate(6320.349 -13441.457)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_2251",
				"data-name": "Group 2251",
				transform: "translate(-4716 14007)",
				children: /* @__PURE__ */ _jsx("circle", {
					id: "Ellipse_551",
					"data-name": "Ellipse 551",
					cx: 11.5,
					cy: 11.5,
					r: 11.5,
					transform: "translate(0.457 0.457)",
					fill: "rgba(0,0,0,0.3)"
				})
			})
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_2310",
			"data-name": "Group 2310",
			transform: "translate(19.094 1.588)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_833",
					"data-name": "Path 833",
					d: "M-4523.652,14701.928l-4.163,4.164,4.163,4.162",
					transform: "translate(6117 -14130)",
					fill: "none",
					stroke: "#fff",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_834",
					"data-name": "Path 834",
					d: "M4.163,0,0,4.163,4.163,8.326",
					transform: "translate(1605.264 580.253) rotate(180)",
					fill: "none",
					stroke: "#fff",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("line", {
					id: "Line_432",
					"data-name": "Line 432",
					x2: 15.841,
					transform: "translate(1589.185 575.774)",
					fill: "none",
					stroke: "#fff",
					strokeWidth: 1
				})
			]
		})]
	})
});
export default SvgFullSize;
